import React from "react";
import { Link } from "react-router-dom";
import { FiBell } from "react-icons/fi";
import { useTranslation } from 'react-i18next';

export default function HeaderUserMenuContent({
  user,
  onSignIn,
  onSignOut,
  onNavigate
}) {

  const { t } = useTranslation();
  if (!user.isSignedIn) {
    return (
      <>
        <button
          className="dropdown-item"
          onClick={onSignIn}
        >
          {t("Signin")}
        </button>

        <Link
          className="dropdown-item"
          to="/customer/account"
          onClick={onNavigate}
        >
          {t("MyAccount")}
        </Link>
      </>
    );
  }
  return (
    <div id="header-user-menu-content">
      {user.isAdmin && (
        <Link
          className="dropdown-item"
          to="/admin"
          onClick={() => onNavigate("/admin")}
        >
          Backoffice
        </Link>
      )}

      <Link
        className="dropdown-item"
        to="/customer/account"
        onClick={onNavigate}
      >
        Mes demandes de formalités
      </Link>
      <Link
        className="dropdown-item"
        to="/customer/account/orders"
        onClick={onNavigate}
      > <span className="d-inline-block  position-relative pe-4">
          Mes commandes {user.pendingOrders > 0 && <span className="badge bg-danger" style={{ bottom: '50%', transform: 'translate-y -50%' }}>{user.pendingOrders}</span>}
        </span>
      </Link>
      <Link
        className="dropdown-item"
        to="/customer/account/profile"
        onClick={onNavigate}
      >
        {t("MyAccount")}
      </Link>

      <button
        className="dropdown-item "
        onClick={onSignOut}
      >
        {t("Signout")}
      </button>
    </div>
  );
}